import { IPosition } from '../../../data-containers/PlaylistTable/components/PlaylistTable';

const computeNotNullSegments = (lineData: any[], key = 'position'): any => {
  let startNewSegment = true;

  // split into segments of continuous data
  const segments = lineData.reduce((segments: any, d: IPosition) => {
    // skip if this point has no data
    if ((d as any)[key] === null) {
      startNewSegment = true;
      return segments;
    }

    // if we are starting a new segment, start it with this point
    if (startNewSegment) {
      segments.push([d]);
      startNewSegment = false;
      // otherwise see if we are adding to the last segment
    } else {
      const lastSegment = segments[segments.length - 1];
      lastSegment.push(d);
    }
    return segments;
  }, []);
  return segments;
};

export default computeNotNullSegments;
